export const handlePrint = async (codId, fetchShipments) => {
  try {
    const shipmentRes = await fetchShipments({ codId }).unwrap();

    // Create an iframe for printing
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`
      <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            .header { display: flex; justify-content: space-between; flex-wrap: wrap; }
            .table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            .table th, .table td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            .table th { background-color: #f2f2f2; }
            .logo { max-width: 150px; max-height: 100px; }
            .text-right { text-align: right; }
          </style>
        </head>
        <body>
          <div class="header">
            <div>
              <img src="${shipmentRes?.logoName || ""}" alt="Company Logo" class="logo" />
            </div>
            <div style="width: 100%;">
              <div style="display: flex; justify-content: space-between;">
                <div>
                  <h3>${shipmentRes?.entityName || "N/A"}</h3>
                  <p>${shipmentRes?.entityLocation || "N/A"}</p>
                  <p>VAT Number: ${shipmentRes?.entityVatNumber || "N/A"}</p>
                  <p>PAN Number: ${shipmentRes?.entityPanNumber || "N/A"}</p>
                  <br />
                  <p>Billing Customer: ${shipmentRes?.data?.[0]?.vendorShopName || "N/A"}</p>
                </div>
                <div class="text-right">
                  <h3>COD Transfer</h3>
                  <h3>#${shipmentRes?.codTransferId || "N/A"}</h3>
                  <br />
                  <p>Date: ${new Date(shipmentRes?.createdAt).toLocaleString("en-US", {
                    timeZone: "Asia/Kathmandu",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })}</p>
                </div>
              </div>
            </div>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Shipment ID</th>
                <th>Customer Name</th>
                <th>Charge</th>
              </tr>
            </thead>
            <tbody>
              ${shipmentRes?.data
                ?.map(
                  (row, index) => `
                    <tr>
                      <td>${index + 1}</td>
                      <td>${row?.shipmentId || "N/A"}</td>
                      <td>${row?.receiver?.customerUser || "N/A"}</td>
                      <td>${
                        row?.shipmentPrices?.reduce(
                          (sum, price) => sum + (price.charge || 0),
                          0
                        ).toFixed(2) || "0.00"
                      }</td>
                    </tr>
                  `
                )
                .join("")}
              <tr>
                <td colspan="3" style="text-align: right; font-weight: bold;">Total Charge</td>
                <td>${
                  shipmentRes?.data
                    ?.reduce(
                      (total, row) =>
                        total +
                        (row?.shipmentPrices?.reduce(
                          (sum, price) => sum + (price.charge || 0),
                          0
                        ) || 0),
                      0
                    )
                    .toFixed(2) || "0.00"
                }</td>
              </tr>
            </tbody>
          </table>
        </body>
      </html>
    `);
    doc.close();

    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    // Clean up
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1000);
  } catch (error) {
    console.error("Failed to fetch shipment data for printing:", error);
    alert("Failed to load print data. Please try again.");
  }
};